import { useExperimentalFeaturesAvailable } from '../../../../hooks/featureChecks'

/**
 * Combined gate for an experimental feature: policy availability AND the
 * user's stored opt-in. Returns `false` whenever the BFF policy denies
 * access, regardless of what's in localStorage — so a previously-enabled
 * feature stops affecting the UI as soon as the policy is revoked, without
 * needing to scrub the user's preferences.
 *
 * Callers pass the current preferences blob (typically from
 * `usePortfolioExplorerPreferences`) rather than re-reading storage so the
 * hook stays pure and composable with the rest of the prefs pipeline.
 *
 * @param {string} key - matches the key in EXPERIMENTAL_FEATURES and
 *   `prefs.experimental.<key>`
 * @param {object} prefs - merged preferences blob
 * @returns {boolean}
 */
export function useExperimentalFeature (key, prefs) {
  const available = useExperimentalFeaturesAvailable()
  if (!available) return false
  return prefs?.experimental?.[key] === true
}
